import { render, staticRenderFns } from "./WorkflowFloatField.vue?vue&type=template&id=7495af96&lang=pug&"
import script from "./WorkflowFloatField.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowFloatField.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports